import React from 'react';
import {
  Box,
  GridColumn,
  ProductGallery,
  useMediaQuery,
} from '@sparknz/spark-pattern-library';
import { LinkRegion, trackCustomLink } from '@sparknz/tracking';

import { useProductDetails } from 'journey/productDetails/provider';
import { PrimaryCategory } from 'journey/productDetails/typings';
import { getTransformedProductImageByImageTypes } from 'shared/utils/getImage.utils';
import ColorOptions from '../ColorOptions';
import QuickLinks from '../QuickLinks';

interface ImageGalleryProps {
  isSticky?: boolean;
  showNavigationArrows?: boolean;
  showPopup?: boolean;
}

export const ImageGalleryBase = ({
  isSticky,
  showNavigationArrows,
  showPopup,
}: ImageGalleryProps) => {
  const { selectedDevice } = useProductDetails();
  const galleryImages = getTransformedProductImageByImageTypes(
    selectedDevice.images,
    ['GALLERY', 'VIDEO'],
  );

  const handleCarouselChange = () => {
    trackCustomLink('carousel interaction');
  };
  const handleProductGalleryZoomableImageClick = () => {
    trackCustomLink('Zoom in');
  };
  const handleSetActiveIndex = (activeIndex: number) => {
    const { mediaType } = galleryImages[activeIndex];
    const linkLabel = mediaType === 'VIDEO' ? 'Video click' : 'Image click';
    trackCustomLink(linkLabel);
  };

  return galleryImages.length ? (
    <LinkRegion regionId="imageGallery" component="span">
      <ProductGallery
        key={selectedDevice.id}
        data={galleryImages}
        isSticky={isSticky}
        showNavigationArrows={showNavigationArrows}
        showPopup={showPopup}
        onCarouselChange={handleCarouselChange}
        onProductGalleryZoomableImageClick={
          handleProductGalleryZoomableImageClick
        }
        onSetActiveIndex={handleSetActiveIndex}
      />
    </LinkRegion>
  ) : null;
};

const ImageGallery = () => {
  const isMobileView = useMediaQuery({ max: 'lil' });
  const { selectedDevice } = useProductDetails();
  const isMobileDeviceSelected =
    selectedDevice.primaryCategory.id === PrimaryCategory.HANDSET;

  return (
    <GridColumn lil={2} slim={3} big={5} bigOffset={1}>
      <ImageGalleryBase showPopup={!isMobileView} />

      {isMobileView ? (
        <Box py="s3">
          <ColorOptions />
        </Box>
      ) : null}

      {isMobileDeviceSelected ? <QuickLinks /> : null}
    </GridColumn>
  );
};

export default ImageGallery;
